import React from 'react'
import Header from '../components/Header'
import Footer from '../components/Footer'

const Shopify = () => {
    return (
        <div className="min-h-screen bg-[#141414] text-white">
            <Header />
            <div className="container mx-auto px-10 pt-40 pb-20">
                <div className="flex items-center justify-between mb-10">
                    <div>
                        <h1 className="text-primary text-[36px]">Shopify Products</h1>
                        <p className="text-[#a3a3a3] mt-2">Shopify-managed items open in the same marketplace details flow.</p>
                    </div>
                </div>

                <div className="text-white/80 text-lg">
                    Shopify catalog items are shown inside the normal marketplace product detail page, alongside platform listings.
                </div>
            </div>
            <Footer />
        </div>
    )
}

export default Shopify
